// extracted by css-extract-rspack-plugin
export default {"table":"hwenP","body":"rpIqg","columnHeader":"MmlOC","itemCell":"aBAlb","itemNameCell":"O0vb_","hideAtXs":"HhtTs","hideAtSm":"ejUes","hideAtMd":"pwfXC"};